import { Router } from '@/constants/router';

import {
  NavigationPortalItem,
  NavPortalItemsEnum,
} from '@/features/ui/navigation';
import { SystemRoleType } from '@pages/BankAccount/SystemUsers/__utils__/mock';

const bankAccountNavItems: NavigationPortalItem[] = [
  {
    id: NavPortalItemsEnum.DASHBOARD,
    path: Router.BankAccount.Dashboard,
    text: 'Dashboard',
  },
  {
    id: NavPortalItemsEnum.ACCOUNT_OVERVIEW,
    path: Router.BankAccount.Overview,
    text: 'Account Overview',
  },
  {
    id: NavPortalItemsEnum.PAYMENTS_AND_PAYEES,
    path: Router.BankAccount.PaymentsAndPayees,
    text: 'Payments & Payees',
  },
  {
    id: NavPortalItemsEnum.AUTHORIZED_CARDHOLDERS,
    text: 'Authorized Cardholders',
    children: [
      {
        id: NavPortalItemsEnum.AUTHORIZED_CARDHOLDERS_DEBIT_LIMITS,
        path: Router.BankAccount.DebitLimits,
        text: 'Spending Limit',
      },
      {
        id: NavPortalItemsEnum.AUTHORIZED_CARDHOLDERS_CARDHOLDERS,
        path: Router.BankAccount.Cardholders,
        text: 'Cardholders',
      },
    ],
  },
  {
    id: NavPortalItemsEnum.BUSINESS_DETAILS,
    path: Router.BankAccount.BusinessDetails,
    text: 'Business Details',
  },
  {
    id: NavPortalItemsEnum.LOCATION_DETAILS,
    path: Router.BankAccount.LocationDetails,
    text: 'Location Details',
  },
  {
    id: NavPortalItemsEnum.SYSTEM_USERS,
    text: 'System Users',
    children: [
      {
        id: NavPortalItemsEnum.SYSTEM_USERS_ROLE,
        path: Router.BankAccount.SystemRoleType,
        text: 'Roles',
      },
      {
        id: NavPortalItemsEnum.SYSTEM_USERS_ITEM,
        path: Router.BankAccount.SystemUsers,
        text: 'Users',
      },
    ],
  },
  {
    id: NavPortalItemsEnum.PAYMENT_SYSTEM_ENROLLMENT,
    path: Router.BankAccount.PaymentSystemEnrollment,
    text: 'Pay-by-Bank',
  },
];

const cardholderNavItems: NavigationPortalItem[] = [
  {
    id: NavPortalItemsEnum.AUTHORIZED_CARDHOLDER_DETAIL,
    path: Router.CardholderRole.Detail,
    text: 'Authorized Cardholders',
  },
];

export const navItems = (userRole: string[]): NavigationPortalItem[] => {
  if (userRole.includes(SystemRoleType.ADMINISTRATIVE)) {
    return bankAccountNavItems;
  }

  if (userRole.includes(SystemRoleType.OPERATING)) {
    return bankAccountNavItems.filter((navItem) =>
      [
        NavPortalItemsEnum.DASHBOARD,
        NavPortalItemsEnum.ACCOUNT_OVERVIEW,
        NavPortalItemsEnum.PAYMENTS_AND_PAYEES,
        NavPortalItemsEnum.AUTHORIZED_CARDHOLDERS,
      ].includes(navItem.id),
    );
  }

  const hasCardholderRole = userRole.includes(SystemRoleType.CARDHOLDER);

  if (userRole.includes(SystemRoleType.ACCOUNTING)) {
    // Role: Accounting
    return bankAccountNavItems
      .filter((navItem) =>
        [
          NavPortalItemsEnum.DASHBOARD,
          NavPortalItemsEnum.ACCOUNT_OVERVIEW,
        ].includes(navItem.id),
      )
      .concat(hasCardholderRole ? cardholderNavItems : []);
  }

  if (hasCardholderRole) {
    return cardholderNavItems;
  }

  return [];
};
